
import React, { useEffect, useState } from "react";
import { Products } from "./Products";
import axios from "axios";
import toast from "react-hot-toast";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setSelected } from "../store/reducers/CartReducer";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
export const BrandsProductsPage = ({lang}) => {

  const [index,setIndex] = useState(-1)

  //const categories =useSelector((state) => state.cart.products);
  const [title,setTitle] = useState('')
  const [title_en,setTitle_en] = useState('')
  const [description,setDescription] = useState('')
  const [description_en,setDescription_en] = useState('')
  const [src,setSrc] = useState('')


  const [pdfs,setPdfs] = useState([])


  const [products,setProducts] = useState([])
  const [animation,setAnimation] = useState(true)
  const [more,setMore] = useState(false)

  const param = useParams()

  const id = param.id;


  const [filter,setFilter] = useState([])


  const [loading,setLoading] = useState(false)
  const [categories, setCategories] = useState([]);

  const dispatch = useDispatch()
  useEffect(() => {
  dispatch( setSelected({select:2}))
}, []);
  useEffect(() => {
  fetchCategories(id);
     
     }, []);
 
     const fetchCategories = async (id) => {

      setLoading(true)
      
 try {
  axios.get(`https://alhubaishi.future-swift.com/Api/BrandCategories.php?id=${id}`)
  .then(res => {
    if(res.data.success === true){

        setTitle(res.data.title)
        setTitle_en(res.data.title_en)
        setSrc(res.data.src)
        setDescription(res.data.description)
        setDescription_en(res.data.description_en)
        setPdfs(res.data.pdf)

        setCategories(res.data.categories);
        setLoading(false)
        if(res.data.categories.length > 0){
            setFilter(res.data.categories[0].children)

            setIndex(0)
            //  setFilter([{code: categories[i].code, value:categories[i].value ,children:categories[i].children}])
            setFilter([{code:res.data.categories[0].code, value:  lang ==='en' ? res.data.categories[0].value_en: res.data.categories[0].value, selected:res.data.categories[0].code ,children:res.data.categories[0].children}])
             
            // fetchProducts(category.code)
            fetchProducts(res.data.categories[0].code)
        }else{
          setAnimation(false);
        }
     
       

    }else{
      
      setLoading(false)
      toast.error(`${res.data.msg}`,{duration: 1000,},)
    
         
        }  
  

  })
} catch (error) { 


throw error;}      


     }

      


     const fetchProducts = async (code) => {


      setAnimation(true)
      
        try {
         axios.get(`https://alhubaishi.future-swift.com/Api/Products.php?code=${code}&brand=${id}`)
         .then(res => {
           if(res.data.success === true){
       
           
             setProducts(res.data.products);
             setAnimation(false);
          
            
              
           }else{
             
       setProducts([])
       setAnimation(false);
   toast.error(`${res.data.msg}`,{duration: 1000,},)
           
                
               }  
         
       
         })
       } catch (error) { 
       
        setAnimation(false);
       throw error;}      
       
       
            }
       



   

  const MenuList = ({ list , code , value , level , selected ,setFilter, fetchProducts }) => { 
    const [Index, setIndex] = useState(-1);
            return (
                <div className={`  `} >
             

               { list.length > 0 ?<div className="w-full flex gap-2  pt-[20px]">
                <h2  style={{fontFamily:'CairoMedium',placeContent:'center'}} className= {`${lang === 'en' ? 'text-left' :'text-right'} w-[20%] text-[13px]  lg:text-[30px]  md:text-[20px]  sm:text-[15px]  xs:text-[13px]  `}>
                {value}
                </h2>
                <div style={{overflowX:'auto'}}  className="flex gap-1 w-[80%] ">
                <button
              style={{fontFamily:'cairoLight'}}
                onClick={()=>{

                    
                    if(  code !== selected){
                        fetchProducts(code)
                    }
                 
                    const arr = filter.filter((v,i)=> i <= level )

            

                    arr[level].selected = code;
           
                setFilter(arr)
           
           }}
                className={` transition-all  duration-500  px-1 py-1  rounded-xl min-w-[80px] max-w-[80px]  ${
                  code === selected
                    ? "text-white drop-shadow-lg bg-primary min-w-[120px] max-w-[120px]   "
                    : "bg-zinc-100   " 
                } h-[35px] `}
              >
                {lang === 'en' ? 'All' : 'الكل' } 
              </button>

                {list.map((listItem, index) => (
                  
                  <MenuItem key={index} code={selected} fetchProducts={fetchProducts} item={listItem} setFilter={setFilter}  level={level} selectedIndex={Index}  setIndex={setIndex} />
                ))}
              
              </div> 
              </div>:''}

              </div>
            );
          }
          
    
    
    
    
          const MenuItem = ({ item , level , code , setFilter ,fetchProducts}) => {
    
        
            return (
              <>
             


           <button
                key={item.code}
                style={{fontFamily:'cairoLight'}}
                onClick={()=>{

                    if( Number(item.code) !==  Number(code)){
                        fetchProducts(item.code)
                    }
              
            if(filter.length-1 === level ){
              

                    const arr = filter;

                    arr[level].selected = item.code;



                setFilter([...arr , {code: item.code, value:item.value ,children:item.children, selected:item.code } ])
        

            }else if(filter.length-1 >= level ){
                const arr = filter.filter((v,i)=> i <= level )

            

                    arr[level].selected = item.code;
           
                setFilter([...arr ,  {code: item.code, value:item.value ,children:item.children, selected:item.code }])
             
                
            }
             
           }}
                className={`transition-all  duration-500  px-1 py-1  rounded-xl min-w-[80px]   ${
                 Number(item.code) ===  Number(code)
                    ? "text-white drop-shadow-lg bg-primary   "
                    : "bg-zinc-100   " 
                } h-[35px] `}
              >
           {lang === 'en' ? item.value_en : item.value }
              </button>
          
              </>
           
            );
          }
          
    
    
    
    
    
    




  return (
    <section  className=" pt-[80px] px-[3%] text-right bg-white min-h-screen w-full">
   <div className="w-full ">
<div   className={`m-auto bg-primary text-white flex w-[90%] px-1 h-[100px] mb-2 rounded`}>
<div className="w-[60%] h-[100px] flex flex-col " >
<div className=" m-auto ">
<p  className=" w-full text-center text-[25px]  ">   {  lang ==='en' ? 'Agents For' : 'وكلاء ماركة'}</p>


<h2 style={{fontFamily:'CairoBold', overflowY:'auto'}} className=" w-full text-center min-h-[50px] max-h-[60px]  text-[25px]"> 
{
  
  loading?    
  <div className="animate-pulse"> <div  className="  m-auto w-[90%]  mt-[20px]   h-4 rounded bg-gray-200 " /> 
  </div> :  lang ==='en' ? title_en :title} 
  
  </h2>

</div>
</div>

<div className="w-[40%] m-auto">

{loading ? 
<div className="animate-pulse">
<div className="m-auto w-full rounded bg-gray-200  h-[95px]  " />
                                </div>
  :             
<img
                  src={`https://alhubaishi.future-swift.com/img/${src}`}
                  alt={``}
                       className="object-contain m-auto w-full max-h-[95px] "
                />}
</div>
</div>   


</div>
<div className="flex w-full">
<button 
onClick={()=>{setMore(!more)}}
 className={`m-auto w-[90%] flex rounded px-2 text-center h-[40px]  border-[1px] border-primary text-primary `} >
<span className="m-auto flex "> {more? lang=== 'en' ? 'Close' :'إغلاق' :  lang=== 'en' ? 'Details' :'تفاصيل'} &ensp; {more ? <FaAngleUp className="m-auto" /> :<FaAngleDown className="m-auto" />}</span> 

 
 </button>

</div>

{more&&
<>
<h2 style={{fontFamily:'CairoExtraBold'}} className={`mt-2 ${lang === 'en' ? 'text-left' :'text-right'} text-[15px]  lg:text-[40px]  md:text-[30px]  sm:text-[20px]  xs:text-[15px] text-zinc-700 `} >
                     {  lang=== 'en' ? 'About' :'عن الوكالة'}
                      </h2>
<p className= {`${lang === 'en' ? 'text-left' :'text-right'}  m-auto w-[90%]`} >
{lang === 'en' ? description_en : description } 
</p>

{pdfs.length > 0 ?
<>
  <h2 style={{fontFamily:'CairoExtraBold'}} className={` mt-2 ${lang === 'en' ? 'text-left' :'text-right'} text-[15px]  lg:text-[40px]  md:text-[30px]  sm:text-[20px]  xs:text-[15px] text-zinc-700 `} >
                     {  lang=== 'en' ? 'More Products' :'مزيد من المنتجات'}
                      </h2>
<div style={{overflowX:'auto'}} className="m-auto w-[90%] flex gap-1 ">
{pdfs.map((item, index) => (
  <a href={`https://alhubaishi.future-swift.com/files/${item.file}`} className={`m-auto rounded px-2 text-center h-[30px] min-w-[100px] border-[1px] border-primary text-primary `}>
  {lang === 'en' ? 'File ' : 'ملف ' }  {index+1}
  </a>
))}
</div>
     {/* Custom <hr/> */}
     <div className="flex mt-6 max-w-full bg-zinc-300 h-[3px] w-full" />
    
</>
:''}

</>

}

{ loading ?


<div  style={{overflowX:'hidden'}} className="m-auto max-w-[90%] flex gap-2 p-1">
{[...Array(10)].map((_, index) => (


<div
          key={index}
          style={{fontFamily:'cairoLight'}}
        
          className={`flex items-center  px-1 py-1  rounded-xl min-w-[140px]
          
             bg-zinc-100   
           h-[50px]  animate-pulse`}
        >
        <div  className="  m-auto w-[80%]    h-2 rounded bg-gray-200 " />
        </div>
    


))}
</div>  

:
      <div style={{overflowX:'auto'}} className="flex max-w-[100%]  mt-2  gap-2 p-1 ">
           
      <button
              
                onClick={()=>{
            
            if(index !== -1){
             setIndex(-1)
             setFilter([])
            
            fetchProducts(0)
            
            }
            
          //  console.log(JSON.stringify(category.products))
           }}
                className={`m-auto transition-all  duration-500  px-1 py-1  rounded-xl min-w-[120px] max-w-[140px]  ${
                  index === -1
                    ? "text-white drop-shadow-lg bg-primary min-w-[160px] max-w-[160px]   "
                    : "bg-zinc-100   " 
                } h-[50px] `}
              >
               {lang === 'en' ? 'All' : 'الكل' } 
              </button>
           
            {categories.map((category, i) => (
              <button
                key={i}
                onClick={()=>{
            
            if(i!==index){
             setIndex(i)
           //  setFilter([{code: categories[i].code, value:categories[i].value ,children:categories[i].children}])
           setFilter([{code:category.code, value:  lang ==='en' ? categories[i].value_en : categories[i].value, selected:category.code ,children:categories[i].children}])
            
            fetchProducts(category.code)
            
            }
            
          //  console.log(JSON.stringify(category.products))
           }}
                className={`m-auto transition-all  duration-500  px-1 py-1  rounded-xl min-w-[120px] max-w-[140px]  ${
                  index === i
                    ? "text-white drop-shadow-lg bg-primary min-w-[160px] max-w-[160px]   "
                    : "bg-zinc-100   " 
                } h-[50px] `}
              >
                 {lang === 'en' ? category.value_en : category.value }
              </button>
            ))}
          </div>
}
          <br />
          <hr />

          {filter.map((item, index) => (
      <MenuList value={item.value} setFilter={setFilter} fetchProducts={fetchProducts} selected={item.selected}  code={item.code} list={item.children } level={index}  />
          
          ))}
       {/* Custom <hr/> */}
      <div className="flex mt-6 max-w-full bg-zinc-300 h-[3px] w-full" />
    
      <Products lang={lang} products={products} animation={animation} />

    </section>
  );
};
